import React from "react";
import { Modal, Button } from "react-bootstrap";

const DeactivateTaskModal = ({ show, onClose, onConfirm, task, processing }) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton={!processing}>
        <Modal.Title>Confirm Deactivate</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to deactivate task?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={processing}>
          Cancel
        </Button>
        <Button variant="warning" onClick={onConfirm} disabled={processing}>
          {processing ? "Deactivating..." : "Deactivate"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeactivateTaskModal;
